import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { eventExist } from './utils'

const EVENT_NAME = 'instaleap_app_loaded'

const wasExecuted = () => eventExist(EVENT_NAME)

const execute = () => {
  if (!wasExecuted()) {
    trackEvent({
      eventName: EVENT_NAME,
      data: {
        access_path_name: window.location.pathname,
      },
    })
  }
}

const appLoaded = {
  EVENT_NAME,
  wasExecuted,
  execute,
}

export default appLoaded
